export default function(accessId) {
    let accessIds = JSON.parse(window.localStorage.getItem('adminuseraccess') || '[]')

	return accessIds.includes(accessId)
}